import { render, staticRenderFns } from "./RolePermissionsList.vue?vue&type=template&id=2490c9de"
import script from "./RolePermissionsList.vue?vue&type=script&lang=js"
export * from "./RolePermissionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports